import { InputType } from 'config'
import { accountTypes } from 'config/user.type.constants'
import { EmailAssigneeOptions, TaskAssigneeOptions } from 'pages/Tasks/constants'
import { loanTypeMap } from 'reducers/loanDetail.reducer'
import { PaymentOrderTypeTitles } from 'services/apis/stripe'
import { timesOption } from 'stories/layouts/FloaterTabs/NotifyBorrower'

export const FileExtensionOptions = {
  pdf: 'PDF',
  xls: 'Xls',
  xlsx: 'Xlsx',
  xlsm: 'Xlsm',
  msg: 'Msg',
  jpeg: 'JPEG',
  jpg: 'JPG',
  png: 'PNG',
  svg: 'Svg',
  wav: 'Wav',
  xml: 'XML',
}

export const getRulesConfigurationFields = (loanGlobalStatus: any) => {
  const rlt: Record<string, InputType> = {
    section1: {
      inputType: 'section',
      title: 'Email Rules',
      span: 'full',
    },
    emailWithdrawnLoans: {
      inputType: 'multiselect',
      title: 'Email Receivers of Withdrawn/Declined Loans',
      options: accountTypes,
      defaultSelected: false,
      required: true,
    },
    emailSurveyNotification: {
      inputType: 'multiselect',
      title: 'Email Receivers of Survey Notification',
      options: accountTypes,
      defaultSelected: false,
      required: true,
    },
    emailWeeklyReport: {
      inputType: 'multiselect',
      title: 'Email Receivers of Weekly Loan Registration Report',
      options: EmailAssigneeOptions(),
      defaultSelected: false,
      required: true,
    },
    section2: {
      inputType: 'section',
      title: 'Task Generation',
      span: 'full',
    },
    revalidateLoan: {
      inputType: 'multiselect',
      title: 'HUD1 Change - Loan Revalidation',
      options: accountTypes,
      defaultSelected: false,
      required: true,
    },
    section7: {
      inputType: 'section',
      title: 'Loan Application',
      span: 'full',
    },
    enableWetSign: {
      inputType: 'togglebutton',
      title: 'Enable Wet Signed Loan App Logic',
    },
    enableOverrideSign: {
      inputType: 'togglebutton',
      title: 'Enable Override Loan App Logic',
    },
    maximumBorrower: {
      inputType: 'text',
      type: 'number',
      title: 'Maximum Borrower',
      maxNumberRange: 8,
    },
    section3: {
      inputType: 'section',
      title: 'Loan Submission / Borrower Auto Notification',
      span: 'full',
    },
    unClearWhenNewDocument: {
      inputType: 'toggle',
      title: 'Unclear condition for new document upload',
      value: false,
      span: 'full',
    },
    borrowerAutoNotifyLoanStatus: {
      inputType: 'multiselect',
      title: 'Loan Status',
      options: loanGlobalStatus,
      defaultSelected: false,
    },
    borrowerAutoNotifyLoanTypes: {
      inputType: 'multiselect',
      title: 'Loan Channel',
      options: loanTypeMap,
      defaultSelected: false,
    },
    borrowerAutoNotifyFrequency: {
      inputType: 'text',
      type: 'number',
      title: 'Days Reminder Frequency',
    },
    borrowerAutoNotifyTime: {
      inputType: 'select',
      title: 'Time',
      options: timesOption,
      allowDefaultOption: false,
      hasDefaultOption: true,
    },
    section4: {
      inputType: 'section',
      title: 'Condition Trigger Rules',
      span: 'full',
    },
    triggerRule: {
      inputType: 'multiselect',
      title: 'Loan Status',
      options: loanGlobalStatus,
      defaultSelected: false,
    },
    section5: {
      inputType: 'section',
      title: 'Contractor/Builder Application',
      span: 'full',
    },
    constructionTrackValidation: {
      title: 'Min Construction Track Records',
      inputType: 'text',
      type: 'number',
    },
    section6: {
      inputType: 'section',
      title: 'Closing Days',
      span: 'full',
    },
    closingDays: {
      title: 'Closing Days',
      inputType: 'text',
      type: 'number',
    },
    section8: {
      inputType: 'section',
      title: 'Document Storage',
      span: 'full',
    },
    fileExtensions: {
      title: 'Allowed Upload File Extension',
      inputType: 'multiselect',
      options: FileExtensionOptions,
      defaultSelected: false,
    },
    section9: {
      inputType: 'section',
      title: 'Loan Detail Restrictions',
      span: 'full',
    },
    loanDetailRestriction: {
      inputType: 'multiselect',
      title: 'Loan Status',
      options: loanGlobalStatus,
      defaultSelected: false,
    },
    section10: {
      inputType: 'section',
      title: 'Rush Restrictions',
      span: 'full',
    },
    rushRestriction: {
      inputType: 'multiselect',
      title: 'Loan Status',
      options: loanGlobalStatus,
      defaultSelected: false,
    },
    manageAccountSection: {
      inputType: 'section',
      title: 'Manage Accounts',
      span: 'full',
    },
    activeLoanStatusForAEDisable: {
      inputType: 'multiselect',
      title: 'Once AE Disabled, Switch AE on loan when status',
      options: loanGlobalStatus,
    },
    borrowerReminderSection: {
      inputType: 'section',
      title: 'Borrower Document Reminder',
      span: 'full',
    },
    isBorrowerReminderOn: {
      inputType: 'togglebutton',
      title: 'Email reminder on Expired Docs',
      span: 'full',
    },
    bReminderStartAfter: {
      inputType: 'text',
      type: 'thousandSepNoDecimal',
      title: 'Start ____ day(s) after expiration',
      tooltip: 'To start before expiration, input negative days',
    },
    bReminderStopAfter: {
      inputType: 'text',
      type: 'thousandSepNoDecimal',
      title: 'Stop ____ day(s) after expiration',
    },
    loanWithdrawnReminderSection1: {
      inputType: 'section',
      title: 'Loan Withdrawn Reminder of Inactivity',
      span: 'full',
    },
    isLoanWithdrawnReminderOn1: {
      inputType: 'togglebutton',
      title: 'Loan Withdrawn Reminder on below status in period',
      span: 'full',
    },
    loanWithdrawnReminderStatus1: {
      inputType: 'multiselect',
      options: loanGlobalStatus,
      title: 'Loan status is in ...',
    },
    loanWithdrawnReminderPeriod1: {
      inputType: 'text',
      type: 'number',
      title: 'in ____ day(s)',
    },
    loanWithdrawnReminderAlarm1: {
      inputType: 'text',
      type: 'number',
      title: 'Send notification in ____ day(s)',
    },
    loanWithdrawnReminderAlarmAssignTo1: {
      inputType: 'multiselect',
      title: 'Notification will be sent to ...',
      options: TaskAssigneeOptions(),
    },
    loanWithdrawnReminderStatusTo1: {
      inputType: 'select',
      options: loanGlobalStatus,
      title: 'Loan Status will change to ...',
    },

    loanWithdrawnReminderSection2: {
      inputType: 'section',
      title: 'Loan Withdrawn Reminder (Not)',
      span: 'full',
    },
    isLoanWithdrawnReminderOn2: {
      inputType: 'togglebutton',
      title: 'Loan Withdrawn Reminder on NOT below status in period',
      span: 'full',
    },
    loanWithdrawnReminderStatus2: {
      inputType: 'multiselect',
      options: loanGlobalStatus,
      title: 'Loan status is NOT in ...',
    },
    loanWithdrawnReminderPeriod2: {
      inputType: 'text',
      type: 'number',
      title: 'in ____ day(s)',
    },
    loanWithdrawnReminderAlarm2: {
      inputType: 'text',
      type: 'number',
      title: 'Send notification in ____ day(s)',
    },
    loanWithdrawnReminderAlarmAssignTo2: {
      inputType: 'multiselect',
      title: 'Notification will be sent to ...',
      options: TaskAssigneeOptions(),
    },
    loanWithdrawnReminderStatusTo2: {
      inputType: 'select',
      options: loanGlobalStatus,
      title: 'Loan Status will change to ...',
    },
    loanSubmissionSelection: {
      inputType: 'section',
      title: 'Loan Submission',
      span: 'full',
    },
    submitToBytepro: {
      inputType: 'multiselect',
      title: 'Submit to Bytepro',
      options: loanGlobalStatus,
      defaultSelected: false,
    },
    paymentMethodsSection: {
      inputType: 'section',
      title: 'Payment Methods',
      span: 'full',
    },
    creditCardPaymentMethods: {
      inputType: 'multiselect',
      title: 'Credit Card',
      options: PaymentOrderTypeTitles,
      defaultSelected: true,
    },
    achBankTransferPaymentMethods: {
      inputType: 'multiselect',
      title: 'ACH Bank Transfer',
      options: PaymentOrderTypeTitles,
      defaultSelected: true,
    },
  }
  return rlt
}
